import { IStoreUpdateManagerState } from './update-manager.interface'

export default {
  workInProgress: [],
} as IStoreUpdateManagerState
